import React from 'react';

import jsPDF from 'jspdf';
import 'jspdf-autotable';

import general from '../../modulos/general';

import _ from 'lodash';

const ImprRC = ({listRCCl, empresa, stImprRC}) => {
  // console.log(stImprRC)
  if(stImprRC){
    let modeloFactura = empresa.modeloFactura
    // console.log(empresa)
      // console.log(listRCCl)
      // console.log(cliente)
    // console.log("entro rc")
    //GENERAR PDF
    let doc = new jsPDF({orientation: 'p', unit: 'mm', format: 'letter'})
    // if(empresa.impRboCaja==="Impresora pequeña 8 cm"){
    //   // doc = new jsPDF({orientation: 'p', unit: 'mm', format: [340, 227]})
    //   doc = new jsPDF({orientation: 'p', unit: 'mm', format: [283, 227]})
    //   // ancho 227 = 80mm y alto 340 = 119.9mm
    // }

    let widthDoc = (doc.internal.pageSize.width)
    // let heightDoc = (doc.internal.pageSize.height)
    // console.log(widthDoc, heightDoc)
    // widthDoc para letter es 215.89999999999998 => se aprox a 216
    // heightDoc para letter es 279.4 => se aprox a 279
    // let numOS = 0
    // let imprRC = false
    let imprRC = true
    let contList = 0
    listRCCl.forEach((elemento, i) => {
      if(empresa.impRboCaja==="Impresora pequeña 8 cm"){
        // doc = new jsPDF({orientation: 'p', unit: 'mm', format: [340, 227]})
        // ancho 227 = 80mm y alto 340 = 119.9mm
        let altoDoc = Math.round((60 * 2.8) + (elemento.listServTar.length * 6 * 2.8))
        if(altoDoc<280){
          altoDoc = 280
        }
        // doc = new jsPDF({orientation: 'p', unit: 'mm', format: [283, 227]})
        doc = new jsPDF({orientation: 'p', unit: 'mm', format: [227, altoDoc]})
        // ancho 227 = 80mm y alto 283 = 100mm  (2.8 = 1mm)
        widthDoc = (doc.internal.pageSize.width - 8)
      }

      // console.log(elemento)
      contList += 1
      // if(elemento.listOS.numeroOS!==numOS){
      //   numOS = elemento.listOS.numeroOS
      //   imprRC = true
      // }else{
      //   imprRC = false
      // }
      
      if(imprRC){
          // console.log(elemento.listServTar)
        let listServTar = elemento.listServTar
        let cliente = elemento.cliente
        let nombreUA = elemento.nombreUA
        let numeroRC = elemento.numeroRC
        let saldoCl = elemento.saldoCl
        let totRecibido = elemento.totRecibido

        // let fechaHoy = new Date()
        // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
        let fechaHoy = elemento.fechaPago

        let linea1DNN = ""
        if(cliente.direccion.descrTipoVia1){
          linea1DNN = cliente.direccion.descrTipoVia1?cliente.direccion.descrTipoVia1:""
          linea1DNN += cliente.direccion.numeroTipoVia1?" " + cliente.direccion.numeroTipoVia1:""
          linea1DNN += cliente.direccion.descrTipoVia2?" " + cliente.direccion.descrTipoVia2:""
          linea1DNN += cliente.direccion.numeroTipoVia2?" " + cliente.direccion.numeroTipoVia2:""
          linea1DNN += cliente.direccion.numeroTipoVia2F?" " + cliente.direccion.numeroTipoVia2F:""
          linea1DNN += cliente.direccion.descrTipoUnd1?" " + cliente.direccion.descrTipoUnd1:""
          linea1DNN += cliente.direccion.numeroTipoUnd1?" " + cliente.direccion.numeroTipoUnd1:""
          linea1DNN += cliente.direccion.descrTipoUnd2?" " + cliente.direccion.descrTipoUnd2:""
          linea1DNN += cliente.direccion.numeroTipoUnd2?" " + cliente.direccion.numeroTipoUnd2:""
        }
        // console.log(listServTar)
        listServTar = _(listServTar)
        .groupBy('descripcionServicio')
        .map((obj, key) => ({
          'descripcionServicio': key,
          'valorRecibido': _.sumBy(obj, 'valorRecibido'),
          'valorDetalle': _.sumBy(obj, 'valorDetalle'),
        }))
        .value()

        // console.log(listServTar)
        let movColecc = []
        listServTar.forEach((elemento1, ii) => {
        // console.log(listRCCl)
        // console.log(listRCCl)
        //Estaba != y se cambió a !== OJOOOOO
          if((elemento1.valorRecibido&&elemento1.valorRecibido!==0)||(elemento1.valorDetalle&&elemento1.valorDetalle!==0)){
            let argsUpd = []
            argsUpd.push(elemento1.descripcionServicio)
            if(elemento1.valorRecibido){
              argsUpd.push('$' + general.formatNum(elemento1.valorRecibido.toString()))
            }
            if(elemento1.valorDetalle){
              argsUpd.push('$' + general.formatNum(elemento1.valorDetalle.toString()))
            }

            movColecc.push(argsUpd)
          }
        })
        // console.log(movColecc)
          // let letrasTotRecibido = numeroALetras(totRecibido)
        if(empresa.impRboCaja==="Tamaño carta"){
          for(let iii=0; iii<2; iii++){
            let letvRC = 0
            if(iii===1){
              letvRC = 135
            }
            doc.lines([[widthDoc-20,0],[0,130],[20-widthDoc,0]], 10,letvRC+10, [1,1], 'S', true)
            doc.line(10, letvRC+34, widthDoc - 10, letvRC+34)
            doc.line(10, letvRC+115, widthDoc - 10, letvRC+115)
            // doc.line(10, letvRC+120, widthDoc - 10, letvRC+120)
            doc.line(12, letvRC+110, widthDoc/4, letvRC+110)
            doc.line((widthDoc)/6, letvRC+34, (widthDoc)/6, letvRC+42)
            doc.line(widthDoc/2, letvRC+34, widthDoc/2, letvRC+42)
            doc.line(widthDoc-(widthDoc/6), letvRC+34, widthDoc-(widthDoc/6), letvRC+42)
            doc.line(widthDoc*2/3, letvRC+115, widthDoc*2/3, letvRC+140)
      
            doc.setFontSize(14);
            doc.setFontType("bold");
            doc.setFontStyle("italic");
            doc.text(empresa.empresaRazonSocial, widthDoc/1.9, letvRC+17, 'center')

            doc.setFontSize(12);
            doc.setFontType("bold");
            doc.text("RECIBO DE CAJA No.", (widthDoc*2.4)/3, letvRC+22, 'center')
            doc.text(`${numeroRC}`, (widthDoc*2.4)/3, letvRC+27, 'center')
            
            doc.setFontSize(10);
            doc.setFontType("normal");
            doc.text(`NIT. ${empresa.empresaNit}`, widthDoc/1.9, letvRC+23, 'center')
            doc.text(`${empresa.empresaDir} ${empresa.empresaTel}`, widthDoc/1.9, letvRC+29, 'center')
    
            doc.setFontSize(6);
            doc.text("CONTRATO", 12, letvRC+37)
            doc.text("CLIENTE", +((widthDoc)/6)+2, letvRC+37)
            doc.text("DIRECCION", (widthDoc/2)+2, letvRC+37)
            doc.text("FECHA", (widthDoc-(widthDoc/6))+2, letvRC+37,)
            // doc.text("SON", 12, letvRC+119)
            doc.text("OBSERVACIONES", 12, letvRC+119)
            doc.text("FIRMA Y SELLO", (widthDoc-5-(widthDoc/6)), letvRC+138, 'center')
            doc.setFontSize(8);
            doc.text(nombreUA, 12, letvRC+109)
            doc.text("Elaborado por:", 12, letvRC+113)
            doc.setFontType("bold");
            doc.text("Saldo pendiente por pagar:", (widthDoc/2)+2, letvRC+113)
            doc.text(`$${general.formatNum(saldoCl.toString())}`, (widthDoc*2/3)+5, letvRC+113)
            doc.setFontType("normal");
            doc.text(cliente.contrato, 12, letvRC+41)
      
            doc.text(`${cliente.nombreCliente} ${cliente.apellidoCliente}`, +((widthDoc)/6)+2, letvRC+41)
            doc.text(linea1DNN, (widthDoc/2)+2, letvRC+41)
            doc.text(fechaHoy, (widthDoc-(widthDoc/6))+2, letvRC+41)
      
            // console.log(listServTar)
            // console.log(movColecc)
      
            // doc.text(letrasTotRecibido, 20, letvRC+119)
            let foot = []
            foot = [["TOTAL", {content: '$' + general.formatNum(totRecibido.toString()), styles: {halign: "right"}}]]

            // foot: [["TOTAL", `$${general.formatNum(totRecibido.toString())}`]],

            doc.autoTable({startY: letvRC+42,
                      tableLineColor: "black",
                      tableLineWidth: 0.1,
                      styles: {
                        // font: 'Calibri',
                        fontSize: 9,
                        lineColor: "black",
                        lineWidth: 0.1
                      },
                      headStyles: {
                        fillColor: "#bdc3c7",
                        textColor: "black",
                        fontSize: 9
                      },
                      bodyStyles: {
                        fillColor: "#E9E4F0",
                        textColor: "black"
                      },
                      columnStyles: {
                        1: {halign: "right"}
                      },
                        alternateRowStyles: {
                        fillColor: "white",
                        textColor: "black"
                      },
                      footStyles: {
                        fillColor: "#bdc3c7",
                        textColor: "black",
                        fontSize: 9
                      },
                      head: [["Concepto", {content: "Valor", styles: {halign: "right"}}]],
                      body: movColecc,
                      foot: foot,
                      margin: {top: 0, left: 10, right: 10},})
      
          //otra forma de addImage => funciona pero necesita un div con id="divLogo" => esta con comentario en recpago2.js
          // var imgSource = document.createElement('img');
          // imgSource.src = "images/logocliente.jpeg";
          // document.getElementById("divLogo").innerHTML = imgSource.outerHTML;
            var imgSource = new Image();
            imgSource.src = "images/logocliente.jpeg";
            doc.convertStringToImageData(imgSource)
            if(modeloFactura==="1"){
              doc.addImage(imgSource, 'PNG', 12, letvRC+12, 66, 20, 'logo');
            }
            if(modeloFactura==="2"||modeloFactura==="3"){
              // doc.addImage(imgSource, 'PNG', 12, letvRC+12, 66, 20, 'logo');
              doc.addImage(imgSource, 'PNG', 12, letvRC+12, 50, 17, 'logo');
            }
          }
        }
        if(empresa.impRboCaja==="Impresora pequeña 8 cm"){
          // console.log(doc.getFontList ())
          for(let iii=0; iii<1; iii++){
            let letvRC = 0
            if(iii===1){
              letvRC = 135
            }
            // doc.addFont('Open Sans')
            // doc.setFont("'Open Sans', san-serif")
            doc.setFont('times')
            doc.setFontSize(8);
            doc.text(empresa.empresaRazonSocial, widthDoc/1.9, letvRC+7, 'center')
            // console.log(empresa.empresaArchFE, empresa.prefijoServ)
            if(empresa.empresaArchFE==="supercablebq"&&empresa.prefijoServ==="b"){
              letvRC += 2
              doc.setFontSize(5);
              doc.text("SUPERCABLE TELECOMUNICACIONES SAS", widthDoc/1.9, letvRC+7, 'center')
              doc.setFontSize(8);
            }
            // doc.setFontSize(6);
            doc.setFontType("normal");
            doc.text(`NIT. ${empresa.empresaNit}`, widthDoc/1.9, letvRC+10, 'center')
            doc.text(`${empresa.empresaDir} ${empresa.empresaTel}`, widthDoc/1.9, letvRC+13, 'center')

            doc.text(`Recibo de caja No. ${numeroRC}     ${fechaHoy}`, (widthDoc)/1.9, letvRC+17, 'center')

            // doc.text("Cliente:", 12, letvRC+21)
            let clienteNombre = `${cliente.contrato}  ${cliente.nombreCliente} ${cliente.apellidoCliente}`.substr(0,35)
            doc.text(clienteNombre, 12, letvRC+21)
            // doc.text(`${cliente.nombreCliente} ${cliente.apellidoCliente}`, 22, letvRC+23)
            // doc.text("Dirección:", 12, letvRC+27)
            linea1DNN = linea1DNN.substr(0,35)
            doc.text(linea1DNN, 12, letvRC+24)

            let foot = []
            foot = [["TOTAL", {content: '$' + general.formatNum(totRecibido.toString()), styles: {halign: "right"}}],
                    [{content: `Saldo pendiente por pagar: $${general.formatNum(saldoCl.toString())}`, styles: {halign: "center"}}],
                    [{content: `Elaborado por: ${nombreUA}`, styles: {halign: "center"}}]]
            doc.autoTable({startY: letvRC+27,
                      tableLineColor: "black",
                      tableLineWidth: 0,
                      styles: {
                        // font: 'san-serif',
                        font: 'times',
                        fontSize: 8.5,
                        lineColor: "black",
                        lineWidth: 0
                      },
                      headStyles: {
                        fillColor: "white",
                        textColor: "black",
                        fontSize: 8.5
                      },
                      bodyStyles: {
                        textColor: "black"
                      },
                      columnStyles: {
                        // 0: {halign: "left"},
                        1: {halign: "right"}
                      },
                      alternateRowStyles: {
                        fillColor: "white",
                        textColor: "black"
                      },
                      footStyles: {
                        fillColor: "white",
                        textColor: "black",
                        fontSize: 8.5
                      },
                      head: [["Concepto", {content: "Valor", styles: {halign: "right"}}]],
                      body: movColecc,
                      foot: foot,
                      margin: {top: 0, left: 9, right: 7},})
          }
        }
        if(contList!==listRCCl.length){
          doc.addPage()
        }
      }
    })
    // let nameDoc = `OS-${listOS.numeroOS}.pdf`
    doc.autoPrint({variant: 'non-conform'});
    // doc.output('dataurlnewwindow'); //abre el pdf en una nueva ventana // OJOOO YA NO FUNCIONA
    // => UTILIZAR
    const pdfBlob = doc.output('blob');
    const url = URL.createObjectURL(pdfBlob);
    window.open(url);
    // doc.save(nameDoc)
  }

  return(
    <div>

    </div> 
  )
}

export default ImprRC